<template>
  <CRow>
    <CCol lg="12">
      <CCard class="shadow-sm">
        <CCardHeader class="">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <CIcon name="cil-book" size="xl" class="mr-3"/>
              <h5 class="mb-0 font-weight-bold">Hướng dẫn sử dụng hệ thống ERP</h5>
            </div>
            <div class="d-flex align-items-center">
              <CButton size="sm" color="info" @click="openPdfGuide" class="mr-2">
                <CIcon name="cil-file" class="mr-1"/>
                Mở hướng dẫn PDF
              </CButton>
              <CButton size="sm" color="light" @click="toggleAll">
                <CIcon :name="allExpanded ? 'cil-chevron-top' : 'cil-chevron-bottom'" class="mr-1"/>
                {{ allExpanded ? 'Thu gọn tất cả' : 'Mở rộng tất cả' }}
              </CButton>
            </div>
          </div>
        </CCardHeader>
        <CCardBody class="p-0">
          <div class="guide-container">
            <div v-for="(section, index) in guideData" :key="index" class="guide-section">
              <div class="section-header" @click="toggleSection(index)">
                <div class="section-header-content">
                  <div>
                    <CIcon :name="section.icon" size="xl"/>
                  </div>
                  <div class="section-info">
                    <h5 class="section-title mb-0">{{ section.title }}</h5>
                    <small class="text-muted">{{ section.description }}</small>
                  </div>
                </div>
                <div class="section-header-actions">
                  <CBadge :color="section.badgeColor" class="mr-3 px-3 py-2">
                    {{ section.items.length }} hướng dẫn
                  </CBadge>
                  <CIcon
                    :name="expandedSections[index] ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"
                    size="lg"
                    :class="{'rotate-icon': expandedSections[index]}"
                  />
                </div>
              </div>

              <CCollapse :show="expandedSections[index]">
                <div class="section-content">
                  <div v-for="(item, itemIndex) in section.items" :key="itemIndex" class="guide-item">
                    <div class="guide-item-header">
                      <div class="item-number">{{ itemIndex + 1 }}</div>
                      <h6 class="item-title mb-0">{{ item.title }}</h6>
                    </div>
                    <div class="guide-item-content">
                      <div v-if="item.steps" class="steps-list">
                        <div v-for="(step, stepIndex) in item.steps" :key="stepIndex" class="step-item">
                          <div class="step-marker">
                            <CIcon name="cil-arrow-right" size="sm"/>
                          </div>
                          <div class="step-content" v-html="step"></div>
                        </div>
                      </div>
                      <div v-else class="single-content" v-html="item.content"></div>

                      <div v-if="item.note" class="guide-note">
                        <CIcon name="cil-info" class="mr-2"/>
                        <span v-html="item.note"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </CCollapse>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'UserGuide',
  data() {
    return {
      allExpanded: false,
      expandedSections: [false, false, false, false],
      guideData: [
        {
          title: 'Quản lý Kho & Linh kiện',
          description: 'Hướng dẫn quản lý linh kiện, nhập xuất kho, tạo danh mục',
          icon: 'cil-storage',
          gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          badgeColor: 'primary',
          items: [
            {
              title: 'Tạo linh kiện từ file excel',
              steps: [
                '<strong>Chuẩn bị:</strong> Tạo file mô tả linh kiện định dạng <code>.xlsx</code> trên máy tính',
                '<strong>Tải lên:</strong> Vào <code>Kho → Nhập/Xuất → Tạo linh kiện từ tệp</code>, chọn file và nhấn <kbd>Tải lên</kbd>',
                '<strong>Kiểm tra:</strong> Vào <code>Kho → Tìm kiếm</code>, bấm vào <kbd>Lựa chọn</kbd> và kiểm tra loại linh kiện vừa được tạo được liệt kê trong danh sách',
                '<strong>Tạo mới linh kiện:</strong> Trong <code>Kho → Tìm kiếm </code> → Nhấn <kbd>Lựa chọn</kbd> → chọn loại linh kiện cần tạo → <kbd>Tạo mới</kbd>. Nhập thông tin vào các trường cho phép và ấn <kbd>Lưu</kbd>'
              ],
              note: 'Đảm bảo file excel có đúng định dạng mẫu của hệ thống'
            },
            {
              title: 'Kiểm soát số lượng và nhập-xuất kho cho từng mã linh kiện',
              steps: [
                '<strong>Tìm kiếm:</strong> Vào <code>Kho → Tìm kiếm</code>, chọn loại linh kiện cần tìm',
                '<strong>Thông tin:</strong> Thông tin hiển thị trong bảng: số lượng tồn, khả dụng, đặt trước',
                '<strong>Lựa chọn:</strong> Để nhập kho hoặc chỉnh sửa số lượng trong từng kho, ấn vào nút trong cột <kbd>Thao tác</kbd> và nhấn <kbd>Cập nhật</kbd> để thực hiện hoặc <kbd>Lịch sử</kbd> để xem lịch sử',
                '<strong>Cập nhật:</strong> Lựa chọn <code>Loại thao tác</code> → <em>Nhập kho</em>, <em>Di chuyển</em> hoặc <em>Cập nhật số lượng</em>, chọn <code>Số lượng, Kho đích, Kho nguồn</code> sau đó ấn <kbd>Nhập</kbd> để xác nhận',
                '<strong>Lịch sử:</strong> Xem và lọc những nội dung cần thiết trong trang lịch sử linh kiện',
              ]
            },
            {
              title: 'Tạo danh mục dành cho mua hàng & nhập-xuất kho',
              steps: [
                '<strong>Mở trang:</strong> <code>Kho → Nhập/Xuất → Tạo danh mục</code>',
                '<strong>Tìm kiếm:</strong> Chọn loại linh kiện (hoặc bỏ trống) sau đó ấn <kbd>Tìm kiếm</kbd>',
                '<strong>Chọn số lượng:</strong> Nhập số lượng vào ô nhập số lượng của từng linh kiện cần',
                '<strong>Chọn vị trí:</strong> Chọn vị trí của từng linh kiện trong cột <kbd>Chọn vị trí</kbd> là nơi cần thao tác xuất nhập kho',
                '<strong>Thêm vào danh mục:</strong> Nhấn <kbd>Thêm/cập nhật mục đã chọn</kbd>',
                '<strong>Quản lý danh mục:</strong> Sử dụng <kbd>Chọn tất cả</kbd> / <kbd>Bỏ chọn</kbd> để thao tác nhanh',
                '<strong>Xóa mục:</strong> Tích chọn mục không cần → <kbd>Bỏ mục đã chọn</kbd>',
                '<strong>Xuất file:</strong> Nhấn <kbd>Xuất danh mục linh kiện</kbd> để tải file excel về máy'
              ],
              note: 'File xuất có thể dùng làm: danh mục mua hàng, phiếu nhập kho, phiếu xuất kho'
            },
            {
              title: 'Nhập/Xuất kho từ tệp danh mục excel đã tạo',
              steps: [
                '<strong>Nhập kho:</strong> vào <code>Kho → Nhập/Xuất → Nhập kho linh kiện theo thông tin từ tệp → Duyệt tệp → Tải lên</code>, nhập "nhap kho" và ấn <kbd>Xác nhận</kbd>, trạng thái xử lý được trả về qua thông báo',
                '<strong>Xuất kho:</strong> vào <code>Kho → Nhập/Xuất → Xuất kho linh kiện theo thông tin từ tệp → Duyệt tệp → Tải lên</code>, nhập "xuat kho" và ấn <kbd>Xác nhận</kbd>, trạng thái xử lý được trả về qua thông báo',
              ],
            },
            {
              title: 'Quản lý tên kho',
              steps: [
                '<strong>Thêm mới kho:</strong> vào <code>Kho → Nhập/Xuất</code> → <strong>Quản lý tên kho linh kiện</strong> → <code>nhập Tên kho → nhập Địa chỉ</code> → <kbd>Thêm kho</kbd>',
                '<strong>Chỉnh sửa kho:</strong> vào <code>Kho → Nhập/Xuất</code> → <strong>Quản lý tên kho linh kiện</strong> → <code>biểu tượng bút chì → Chỉnh sửa tên kho và Địa chỉ</code> → ấn <kbd>V</kbd> để xác nhận',
              ],
            }
          ]
        },
        {
          title: 'Quản lý Dự án & BOM',
          description: 'Tạo dự án, quản lý BOM, theo dõi tiến độ sản xuất',
          icon: 'cil-briefcase',
          gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          badgeColor: 'success',
          items: [
            {
              title: 'Tạo dự án mới',
              steps: [
                'Vào <code>Dự án → Thêm mới</code>',
                '<strong>Quy tắc đặt tên:</strong> <code>&lt;Tên sản phẩm&gt;-&lt;Khách hàng&gt;-&lt;Ngày bắt đầu&gt;</code>',
                'Điền đầy đủ thông tin bắt buộc (có dấu <span class="text-danger">*</span>)',
                'Nhấn <kbd>Lưu</kbd> để hoàn tất'
              ]
            },
            {
              title: 'Cập nhật trạng thái dự án',
              steps: [
                'Vào <code>Dự án</code> → Click vào dự án cần chỉnh sửa',
                'Cập nhật: trạng thái, tiến độ, thông tin thiết kế, vật tư, sản xuất',
                'Nhấn <kbd>Lưu</kbd> để cập nhật thay đổi'
              ]
            },
            {
              title: 'Xem tiến độ sản xuất, giao hàng, bảo hành',
              steps: [
                'Vào <code>Dự án</code> → Click vào dự án cần xem',
                'Thanh tiến trình hiển thị: % sản xuất, giao hàng, bảo hành',
                '<strong>Xem chi tiết:</strong> Click vào thanh tiến trình để xem danh sách chi tiết'
              ]
            },
            {
              title: 'Tạo và biên tập BOM',
              steps: [
                '<strong>Tạo BOM mới:</strong> Tại trang dự án → Chọn <kbd>Tạo mới</kbd> → Nhập tên BOM và số lượng → <kbd>Lưu</kbd>',
                '<strong>Nhập thiết kế:</strong> Chọn <kbd>Biên tập</kbd> → Phần "Thông tin thiết kế" → Chọn file BOM schematic (.xlsx)',
                '<strong>Xem tổng hợp:</strong> Mục "Thông tin tổng hợp" hiển thị kết quả xử lý, <span class="text-danger">linh kiện thiếu bôi đỏ</span>',
                '<strong>Rà soát kho:</strong> Nhập thông tin rà soát → Hệ thống tính số lượng thiếu và cần mua',
                '<strong>Tạo danh mục mua:</strong> Nhập số lượng mua cho từng loại thiếu → <kbd>Xuất danh mục mua</kbd>',
                '<strong>Đồng bộ sau nhập kho:</strong> Nhấn <kbd>Đồng bộ</kbd> → Nếu đủ linh kiện sẽ xuất BOM và xuất kho tự động'
              ],
              note: 'Có thể gửi email danh mục mua cho nhà cung cấp'
            }
          ]
        },
        {
          title: 'Thông báo & Nhắc nhở',
          description: 'Cảnh báo linh kiện thiếu, deadline dự án',
          icon: 'cil-bell',
          gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
          badgeColor: 'warning',
          items: [
            {
              title: 'Thông báo tự động',
              content: 'Hệ thống tự động nhắc nhở về: <strong>linh kiện sắp hết</strong>, <strong>dự án gần deadline</strong>, <strong>thiết bị cần bảo hành</strong> qua các kênh đã cấu hình'
            }
          ]
        },
        {
          title: 'Quản lý Sản phẩm & Thiết bị',
          description: 'Theo dõi thiết bị, giấy phép, giao hàng, bảo hành',
          icon: 'cil-layers',
          gradient: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)',
          badgeColor: 'info',
          items: [
            {
              title: 'Theo dõi thiết bị online',
              content: 'Vào <code>Quản lý → Kết nối</code> để xem danh sách thiết bị đang hoạt động và kết nối Internet'
            },
            {
              title: 'Xem lịch sử sản xuất',
              content: 'Tra cứu thiết bị đã sản xuất theo: <strong>số seri</strong>, <strong>UUID</strong>, <strong>MAC</strong>, <strong>lô sản xuất</strong>, <strong>thời gian</strong>'
            },
            {
              title: 'Quản lý giấy phép thiết bị',
              steps: [
                'Vào <code>Quản lý → Giấy phép</code> để xem danh sách license đã cấp',
                'Nhấn <kbd>Tạo mới</kbd> để cấp giấy phép tính năng cho thiết bị'
              ]
            },
            {
              title: 'Quản lý giao hàng',
              content: 'Ghi nhận: <strong>sản phẩm giao</strong>, <strong>thời gian & địa điểm</strong>, <strong>người giao/nhận</strong>, <strong>biên bản bàn giao</strong>'
            },
            {
              title: 'Quản lý bảo hành',
              steps: [
                '<strong>Nhận hàng:</strong> Ghi nhận sản phẩm nhận bảo hành, số lượng, thời gian',
                '<strong>Sửa chữa:</strong> Phân công người sửa, linh kiện thay thế',
                '<strong>Trả hàng:</strong> Ghi nhận thời gian hoàn thành và trả khách'
              ]
            }
          ]
        }
      ]
    }
  },
  methods: {
    toggleSection(index) {
      this.$set(this.expandedSections, index, !this.expandedSections[index])
    },
    toggleAll() {
      this.allExpanded = !this.allExpanded
      this.expandedSections = this.expandedSections.map(() => this.allExpanded)
    },
    openPdfGuide() {
      window.open('https://erp.ees.com.vn/static/document/hdsd.pdf', '_blank')
    }
  }
}
</script>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.guide-container {
  padding: 0.75rem;
}

.guide-section {
  margin-bottom: 1rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 1rem;
  background: white;
  cursor: pointer;
  border-bottom: 2px solid #f0f0f0;
  transition: all 0.3s ease;
}

.section-header:hover {
  background: #f8f9fa;
}

.section-header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
}

.section-info {
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
}

.section-header-actions {
  display: flex;
  align-items: center;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.section-content {
  padding: 1rem;
  background: #f2f4f6;
}

.guide-item {
  border-radius: 6px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid #e0e0e0;
  background-color: white;
}

.guide-item:last-child {
  margin-bottom: 0;
}

.guide-item-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.item-number {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.item-title {
  font-weight: 600;
  color: #2c3e50;
  /* font-size: 1rem; */
}

.guide-item-content {
  padding-left: 2.5rem;
}

.steps-list {
  margin-bottom: 1rem;
}

.step-item {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  line-height: 1.35;
}

.step-marker {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: #e8eaf6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  margin-top: 2px;
}

.step-content {
  flex: 1;
  line-height: 1.35;
}

.single-content {
  line-height: 1.8;
}

.guide-note {
  /* margin-top: 1rem; */
  padding: 0.75rem 1rem;
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  color: #856404;
}

/* Text formatting */
::v-deep code {
  background: #f1f3f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.9em;
  color: #e83e8c;
  font-weight: 500;
}

::v-deep kbd {
  background: #212529;
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  font-weight: 500;
}

::v-deep strong {
  color: #2c3e50;
  font-weight: 600;
}

::v-deep em {
  color: #6c757d;
  font-style: italic;
}
</style>
